import React, { useState, useEffect, useRef } from "react";
import "./StaggeredText.css"; // We'll update this CSS file

const StaggeredText = ({
  text,
  className,
  as: Element = "h1",
  staggerDelay = 0.05,
  animationDuration = 0.5,
  threshold = 0.1, // How much of the element should be visible to trigger
  once = false, // Set to true if you want it to animate only once
}) => {
  const [isInView, setIsInView] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false); // To control 'once' behavior
  const containerRef = useRef(null);
  const chars = text.split("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!once || !hasAnimated) {
            setIsInView(true);
            if (once) {
              setHasAnimated(true);
            }
          }
        } else {
          // Reset if it should animate every time
          if (!once) {
            setIsInView(false);
          }
        }
      },
      {
        threshold: threshold, // Trigger when 10% of the element is visible
        // root: null, // observing intersections with the viewport
        // rootMargin: '0px'
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, once, hasAnimated]); // Rerun effect if threshold or once changes

  return (
    <Element ref={containerRef} className="staggered-text-container">
      {chars.map((char, index) => (
        <span
          key={`${char}-${index}`} // More robust key
          className={`staggered-char ${
            isInView ? "is-visible" : ""
          } ${className}`}
          style={{
            // Apply animation properties only when is-visible is true
            // The actual animation-name will come from the CSS class
            animationDuration: isInView ? `${animationDuration}s` : undefined,
            animationDelay: isInView ? `${index * staggerDelay}s` : undefined,
          }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </Element>
  );
};

export default StaggeredText;
